import React, { useEffect, useState } from "react";
import { fetchHomonyms, deleteHomonym, searchHomonyms } from "./adminHomonymService";
import HomonymForm from "./HomonymForm";
import "../../blog/tongueTwister.css";

const BASE_ROOT = process.env.REACT_APP_BASE_URL_ROOT || "";
const toPublicImgSrc = (url) => {
  if (!url) return "";
  const pub = url.replace(/\/api(?:\/admin)?\/media-images\//, "/api/public/media-images/");
  const src = pub.startsWith("http") ? pub : `${BASE_ROOT}${pub}`;
  console.log("[AdminHomonymPage] img raw:", url, "→ resolved:", src);
  return src;
};

const AdminHomonymPage = () => {
 const [items, setItems] = useState([]);
 const [loading, setLoading] = useState(false);
 const [showForm, setShowForm] = useState(false);
 const [editing, setEditing] = useState(null);
 const [search, setSearch] = useState("");
 const [page, setPage] = useState(0);
 const [totalPages, setTotalPages] = useState(0);

 useEffect(() => { loadItems(); }, [page, search]);

 const loadItems = async () => {
 setLoading(true);
 const params = { page, size: 20 };
 const res = search
 ? await searchHomonyms({ keyword: search, ...params })
 : await fetchHomonyms(params);

 if (res.status === 200 && res.data) {
 setItems(res.data.content || []);
 setTotalPages(res.data.totalPages || 0);
 } else {
 setItems([]);
 alert(res.message || "Failed to load");
 }
 setLoading(false);
 };

 const handleDelete = async (id) => {
 if (!window.confirm("Delete this homonym?")) return;
 const res = await deleteHomonym(id);
 if (res.status === 200 || res.status === 204) loadItems();
 else alert(res.message);
 };

 const onSaved = () => { setShowForm(false); setEditing(null); loadItems(); };

 return (
 <div className="admin-container">
 <div className="admin-header">
 <h2>Homonyms</h2>
 <button onClick={() => { setEditing(null); setShowForm(true); }}>+ New Homonym</button>
 </div>

 {showForm && (
 <HomonymForm homonym={editing} onSaved={onSaved} onCancel={() => setShowForm(false)} />
 )}

 <div style={{ display: "flex", gap: 10, marginBottom: 20 }}>
 <input
 type="text" placeholder="Search homonyms..."
 value={search} onChange={(e) => { setPage(0); setSearch(e.target.value); }}
 style={{ flex: 1, padding: "8px 12px", borderRadius: 6, border: "1px solid #ccc" }}
 />
 </div>

 {loading ? (
 <p>Loading...</p>
 ) : (
 <table className="announcement-table">
 <thead>
 <tr>
 <th>Image</th>
 <th>Word</th>
 <th>IPA</th>
 <th>Phonetic</th>
 <th>Meanings</th>
 <th>Sort</th>
 <th>Actions</th>
 </tr>
 </thead>
 <tbody>
 {items.length === 0 ? (
 <tr><td colSpan="7">No homonyms found</td></tr>
 ) : (
 items.map((h) => (
 <tr key={h.id}>
 <td>
 {h.imageUrl ? (
 <img src={toPublicImgSrc(h.imageUrl)} alt="" style={{ width: 44, height: 44, objectFit: "contain", background: "#f5f5f5", borderRadius: 6, border: "1px solid #eee" }} />
 ) : (
 <div style={{ width: 44, height: 44, background: "#f5f5f5", borderRadius: 6, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, color: "#bbb" }}>—</div>
 )}
 </td>
 <td style={{ fontWeight: 600 }}>{h.word}</td>
 <td>{h.ipaPronunciation || "—"}</td>
 <td>{h.phoneticPronunciation || "—"}</td>
 <td style={{ textAlign: "center" }}>{h.meaningCount ?? "—"}</td>
 <td style={{ textAlign: "center" }}>{h.sortOrder ?? "—"}</td>
 <td>
 <button onClick={() => { setEditing(h); setShowForm(true); }}>Edit</button>
 <button className="delete-btn" onClick={() => handleDelete(h.id)}>Delete</button>
 </td>
 </tr>
 ))
 )}
 </tbody>
 </table>
 )}

 {totalPages > 1 && (
 <div style={{ marginTop: 20 }}>
 <button disabled={page === 0} onClick={() => setPage(page - 1)}>Prev</button>
 <span style={{ margin: "0 10px" }}>Page {page + 1} / {totalPages}</span>
 <button disabled={page + 1 >= totalPages} onClick={() => setPage(page + 1)}>Next</button>
 </div>
 )}
 </div>
 );
};

export default AdminHomonymPage;
